module.exports = __webpack_public_path__ + "static/media/pic3.1839628f.jpg";